import { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import CustomButton from "../../Components/Base/CustomButton";
import InputTextBox from "../../Components/Base/InputTextBox";
import SelectOption from "../../Components/Base/SelectOption";
import Loader from "../../Components/Loder";
import PageBar from "../../Components/ToolBar/PageBar";
import ToolBar from "../../Components/ToolBar/ToolBar";
import AppContext from "../../Context/AppContext";
import { RestReportBean } from "../../Ds/client_ds";
import InValidAccess from "../../Components/InValidAccess";
import {
  PageListBean,
  RestSKUBatchInventoryTrackListRequest,
  SKUBatchInventoryTrackSearchCriteria,
  RestFabricStyleListRequest,
  FabricStyleSearchCriteria,
} from "../../Ds/ds";
import service from "../../Services/Service";
import {
  PK_LOCATION,
  TOAST_ERROR,
  TOAST_SUCESS,
  TOAST_WARN,
} from "../../Utils/appConstants";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  getSuggestions,
  ColumnDefinition,
} from "../../Utils/util";
import { SecurityAccessManager } from "../../Security/SecurityAccessManager";
import NoData from "../../Components/NoData";
import { MOREOPTIONICON } from "../../Utils/icons";
import Modal from "../../Components/Modal";
import CustomTable from "../../Components/Base/CustomTable";
import ViewToggle from "../../Components/ViewToggle";

export default function SkuBatchInquiry() {
  const { token, setisSessionExpeired, session } = useContext(AppContext);
  const [view, setView] = useState(window.innerWidth <= 768 ? 1 : 2);
  const [customerCode, setCustomerCode] = useState("");
  const [dataList, setDataList] = useState([]);
  const [criteria, setCriteria] = useState(
    new SKUBatchInventoryTrackSearchCriteria()
  );
  const title = "SKU Batch Inventory Track";
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowPdf, setIsShowPdf] = useState(false);
  const [isShowExcel, setIsShowExcel] = useState(false);
  const [disable, setDisable] = useState(false);
  const inputRef = useRef(null);
  const buttonRef = useRef(null);
  const [items, setItems] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [isAccessible, setIsAccessible] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [trackData, setTrackData] = useState({});
  const [version, setVersion] = useState(2);
  const [isTable, setIsTable] = useState(false);

  useEffect(() => {
    function handleResize() {
      setView(getDefaultView());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getDefaultView() {
    return window.innerWidth <= 768 ? 1 : 2;
  }
  const listViewHandler = () => {
    setView(1);
  };
  const gridViewHandler = () => {
    setView(2);
  };
  const setFocus = () => {
    if (inputRef.current != null) inputRef.current.focus();
  };

  const asignDefault = () => {
    const _criteria = new SKUBatchInventoryTrackSearchCriteria();
    _criteria.companyCode = process.env.REACT_APP_COMPANY;
    if (!isEmpty(session)) {
      const { entityCode, code } = session;
      if (!isEmptyString(entityCode)) {
        _criteria.logisticCustomerCode = entityCode;
        setCustomerCode(entityCode);
      }
      if (!isEmptyString(code)) _criteria.customerUserCode = code;
    }
    setCriteria(_criteria);
  };

  useEffect(() => {
    setFocus();
    getItemlList();
    asignDefault();
  }, []);

  const notify = (type, msg, theme) => {
    if (type === 1)
      toast.info(msg, {
        theme: theme,
      });
    else if (type === 2)
      toast.error(msg, {
        theme: theme,
      });
    else if (type === 3)
      toast.success(msg, {
        theme: theme,
      });
    else if (type === 4)
      toast.warn(msg, {
        theme: theme,
      });
    else toast(msg);
  };

  const errorCallBack = (error) => {
    setIsLoading(false);
    notify(TOAST_ERROR, error.message);
  };

  const handleGetItemListResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.fabricStylePageList) &&
          !isEmptyArray(response.data.fabricStylePageList.fabricStyles)
        ) {
          const _list = new Array();
          response.data.fabricStylePageList.fabricStyles.map((ln) => {
            _list.push(ln.code);
          });
          setItems(_list);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };

  const getItemlList = () => {
    if (SecurityAccessManager.ItemMaintenanceView_IsAccessible()) {
      const request = new RestFabricStyleListRequest();
      const criteria = new FabricStyleSearchCriteria();
      criteria.companyCode = process.env.REACT_APP_COMPANY;
      if (!isEmpty(session)) {
        const { entityCode, code } = session;
        if (!isEmptyString(entityCode))
          criteria.logisticCustomerCode = entityCode;
        if (!isEmptyString(code)) criteria.customerUserCode = code;
      }
      const pageInput = new PageListBean();
      // pageInput.currentPage = 1;
      // pageInput.pageSize = pageSize;

      request.searchCriteria = criteria;
      request.pageInput = pageInput;

      const path = "getItemListBasedOnCustomer";
      service(token, path, request, handleGetItemListResponse, errorCallBack);
    } else {
      setIsAccessible(true);
    }
  };

  const handleReportResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (response.data != null) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (response.data.reportResult != null) {
          if (!isEmptyString(response.data.reportResult.reportFileID)) {
            let reportFilePath = response.data.reportResult.reportFileID;
            window.open(
              `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_REPORT_PATH}` +
                reportFilePath
            );
          }
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => {
            msg_List.push(info.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_SUCESS, msg);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };

  const generateReport = (type) => {
    // const criteria = new SKUBatchInventoryTrackSearchCriteria();
    // criteria.fabricStyleCodeContains = code;
    // criteria.fabricStyleCodeStartsWith = code;

    // criteria.logisticCustomerCode = customerCode;

    // criteria.companyCode = process.env.REACT_APP_COMPANY;
    const reportBean = new RestReportBean();
    reportBean.reportType = type;
    const pageInput = new PageListBean();
    pageInput.currentPage = 1;
    // pageInput.pageSize = pageSize;
    const request = new RestSKUBatchInventoryTrackListRequest();
    request.criteria = criteria;
    request.reportBean = reportBean;
    request.pageInput = pageInput;
    const path = "generateSkubatchInventoryTrackPrintOutReport";
    service(token, path, request, handleReportResponse, errorCallBack);
  };

  const PDFHandler = () => {
    if (
      SecurityAccessManager.SkuBatchInventoryTrackInquiryPDFReport_IsAccessible()
    ) {
      setIsLoading(true);
      generateReport(1);
    } else {
      setIsAccessible(true);
    }
  };

  const ExcelHandler = () => {
    if (
      SecurityAccessManager.SkuBatchInventoryTrackInquiryExcelReport_IsAccessible()
    ) {
      setIsLoading(true);
      generateReport(2);
    } else {
      setIsAccessible(true);
    }
  };

  const handleResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.inventoryTrackPageList) &&
          !isEmptyArray(
            response.data.inventoryTrackPageList.skuBatchInventoryTracks
          )
        ) {
          setDataList(
            response.data.inventoryTrackPageList.skuBatchInventoryTracks
          );
          if (response.data.inventoryTrackPageList.totalCount != null) {
            const total_Count = response.data.inventoryTrackPageList.totalCount;
            const maxPage = Math.ceil(total_Count / pageSize);
            setTotalCount(total_Count);
            setIsShowExcel(true);
            setIsShowPdf(true);
            setMaxPage(maxPage);
          }
          if (response.data.inventoryTrackPageList.currentPage != null) {
            setPage(response.data.inventoryTrackPageList.currentPage);
          }
        }
        if (
          !isEmpty(response.data.inventoryTrackPageList) &&
          isEmptyArray(
            response.data.inventoryTrackPageList.skuBatchInventoryTracks
          )
        ) {
          notify(TOAST_WARN, "No Data Found");
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => {
            msg_List.push(info.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_SUCESS, msg);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };

  const ExecuteHandler = () => {
    loadPage(1);
  };

  const loadPrevious = () => {
    if (page > 1) {
      const pagenumber = parseInt(page) - 1;
      loadPage(pagenumber);
    }
  };

  const loadNext = () => {
    if (maxPage > page) {
      const pagenumber = parseInt(page) + 1;
      loadPage(pagenumber);
    }
  };

  const loadFirst = () => {
    loadPage(1);
  };

  const loadLast = () => {
    loadPage(maxPage);
  };

  const loadPage = (id) => {
    if (SecurityAccessManager.SkuBatchInventoryTrackInquiry_IsAccessible()) {
      setDataList([]);
      setIsLoading(true);
      const request = new RestSKUBatchInventoryTrackListRequest();
      // const criteria = new SKUBatchInventoryTrackSearchCriteria();
      // criteria.companyCode = process.env.REACT_APP_COMPANY;
      // criteria.fabricStyleCodeContains = code;
      // if (!isEmpty(session)) {
      //   const { entityCode, code } = session;
      //   criteria.logisticCustomerCode = entityCode;
      //   criteria.customerUserCode = code;
      // }
      // criteria.fabricStyleCodeContains = code;

      criteria.excludedLocationCodes = [PK_LOCATION];
      const pageInput = new PageListBean();
      pageInput.currentPage = id;
      pageInput.pageSize = pageSize;
      request.searchCriteria = criteria;
      request.pageInput = pageInput;
      const path = "getSkuBatchInventoryTrackPageList";
      service(token, path, request, handleResponse, errorCallBack);
    } else {
      setIsAccessible(true);
    }
  };

  const enterKeyHandler = (e) => {
    loadFirst();
  };

  const buttonHandler = (e) => {
    loadFirst();
  };

  const onClose = () => {
    setIsAccessible(false);
  };

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    const inputValue = type === "checkbox" ? checked : value;
    setCriteria((prevState) => ({
      ...prevState,
      [name]:
        type === "number" ? parseFloat(inputValue).toFixed(2) : inputValue,
    }));
    setSuggestions(getSuggestions(items, value));
  };

  const ResetHandler = () => {
    setDataList([]);
    setDisable(false);
    setIsShowExcel(false);
    setIsShowPdf(false);
    setSuggestions([]);
    setCriteria(new SKUBatchInventoryTrackSearchCriteria());
    // getItemlList();
    asignDefault();
    setFocus();
  };

  const closeModal = () => {
    setIsShowModal(false);
  };

  const MoreOptionHandler = (data) => {
    setTrackData(data);
    setIsShowModal(true);
  };

  const Columns = () => {
    const _columns = new Array();

    _columns.push(
      new ColumnDefinition()
        .setDetails("Item", "fabricStyleCode", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "10", "", "wt-3", "wt-3")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Inventory", "rollSkuNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("LotNumber", "vendorBatchNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Sequence", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "", true)
        .setStyleDetails("center", "", "", "", "")
        .setSpanDetails(false, true, 3)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("OpenQty", "previousOnHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setSpanDetails(true)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("ChangeQty", "changeOnHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setSpanDetails(true)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("CloseQty", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setSpanDetails(true)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Process", "updateEntityCode", true)
        .setStyleDetails("left", "", "", "wt-6", "wt-6")
        .setSpecialDetails(true, "updateEntityType")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Date", "createdDate", true)
        .setStyleDetails("left", "5", "", "wt-4", "wt-4")
    );

    // _columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Item", "fabricStyleCode", true)
    //     .setStyleDetails("left", "7", "", "wt-5", "")
    // );
    // _columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Name", "fabricStyleName", true)
    //     .setStyleDetails("left", "7", "", "wt-5", "")
    // );
    // _columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Color", "fabricStyleColorCode", true)
    //     .setStyleDetails("left", "4", "", "wt-5", "")
    // );
    // _columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Location", "locationCode", true)
    //     .setStyleDetails("left", "3", "", "wt-3", "wt-3")
    // );
    // _columns.push(
    //   new ColumnDefinition()
    //     .setDetails("UOM", "updateEntityCode", true)
    //     .setStyleDetails("left", "3", "", "wt-3", "wt-3")
    // );
    // _columns.push(
    //   new ColumnDefinition()
    //     .setDetails("OrderQty", "orderQuantity", true, true)
    //     .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    // );
    // _columns.push(
    //   new ColumnDefinition()
    //     .setDetails("RcdQty", "receivedQuantity", true, true)
    //     .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    // );
    // _columns.push(
    //   new ColumnDefinition()
    //     .setDetails("OpenQty", "openQuantity", true, true)
    //     .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    // );
    // _columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Location", "locationCode", true)
    //     .setStyleDetails("left", "3", "", "wt-3", "wt-3")
    // );
    // _columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Status", "lineStatus", true)
    //     .setStyleDetails("left", "2", "", "wt-3", "wt-3")
    // );
    return _columns;
  };

  return (
    <>
      {isLoading ? <Loader /> : null}
      <Modal isOpen={isShowModal} onClose={closeModal} title={"Track Detail"}>
        {!isEmpty(trackData) ? (
          <div className="row">
            <div className="form-group col-5">
              <InputTextBox
                label={"SKU Number"}
                value={trackData.skuNumber}
                required={true}
                disable={true}
              />
            </div>{" "}
            <div className="form-group col-5">
              <InputTextBox
                label={"Sequence"}
                value={trackData.rollNumber}
                required={true}
                disable={true}
              />
            </div>{" "}
            <div className="form-group col-5">
              <InputTextBox
                label={"Inventory"}
                value={trackData.rollSkuNumber}
                required={true}
                disable={true}
              />
            </div>{" "}
            <div className="form-group col-5">
              <InputTextBox
                label={"Lot"}
                value={trackData.vendorBatchNumber}
                required={true}
                disable={true}
              />
            </div>{" "}
            <div className="form-group col-5">
              <InputTextBox
                label={"Bin"}
                value={trackData.aisleInfoText}
                required={true}
                disable={true}
              />
            </div>
          </div>
        ) : null}
      </Modal>
      <ToolBar
        title={title}
        PDFHandler={PDFHandler}
        ExcelHandler={ExcelHandler}
        ResetHandler={ResetHandler}
        ExecuteHandler={ExecuteHandler}
        isShowPdf={isShowPdf}
        isShowExcel={isShowExcel}
      />

      <div className="card-body">
        <div className="row">
          <div className="form-group col-5">
            <InputTextBox
              label={"Customer"}
              value={customerCode}
              required={true}
              disable={true}
            />
          </div>
          {/* <div className="form-group col-5">
            <InputTextBox
              value={criteria.fabricStyleCodeContains}
              // value={code}
              required={true}
              name="fabricStyleCodeContains"
              placeholder={"enter item Code"}
              label={"Item Code"}
              enterKeyHandler={enterKeyHandler}
              onChange={onChange}
              disable={disable}
              inputRef={inputRef}
              suggestionList={items}
              suggestions={suggestions}
            />
          </div> */}
          <div className="form-group col-5">
            <SelectOption
              value={criteria.fabricStyleCodeContains}
              // value={code}
              required={true}
              name="fabricStyleCodeContains"
              label={"Item Code"}
              onChange={onChange}
              disable={disable}
              inputRef={inputRef}
              options={items}
            />
          </div>
          <div className="form-group col-fit">
            <CustomButton
              buttonHandler={buttonHandler}
              disable={disable}
              buttonRef={buttonRef}
              label={"Fetch"}
            />
          </div>
        </div>
      </div>
      {!isEmptyArray(dataList) ? (
        <PageBar
          loadFirst={loadFirst}
          loadNext={loadNext}
          loadPrevious={loadPrevious}
          loadLast={loadLast}
          page={page}
        />
      ) : null}
      {!isEmptyArray(dataList) ? (
        <ViewToggle
          listViewHandler={listViewHandler}
          gridViewHandler={gridViewHandler}
        />
      ) : null}
      {!isEmptyArray(dataList) ? (
        <div className="card-body">
          <div className="card-title">
            <h1>SKU Batch Track Details</h1>
          </div>
          <div className="list-wrap">
            {view === 2 ? (
              <>
                <CustomTable
                  columns={Columns}
                  data={dataList}
                  isShowFullScreen={true}
                  isEnableSpan={true}
                />
              </>
            ) : (
              <>
                {dataList.map((ln, idx) => {
                  return (
                    <div className="list-itm" key={idx}>
                      {version == 1 ? (
                        <>
                          <div className="">
                            <span className="_imp">{ln.fabricStyleCode}</span>(
                            {ln.fabricStyleName}) <br />{" "}
                            {ln.fabricStyleColorCode} -{" "}
                            <span className="imp">{ln.locationCode}</span>
                          </div>
                          <div className="">
                            <span className="_imp">{ln.updateEntityCode}</span>{" "}
                            - {ln.updateEntityType}
                          </div>
                          <div className="tb-flex">
                            <div>OnHand Qty</div>
                            <div>
                              ({" "}
                              <span className="_imp">
                                {toCommaSeperatedAmount(ln.onHandQuantity)}
                              </span>{" "}
                              ) {ln.uomCode}
                            </div>
                          </div>
                          <div className="tb-flex">
                            <div className="sub-tb-flex">
                              <div>Open</div>/<div>Change</div>
                            </div>
                            <div className="sub-tb-flex">
                              <div>
                                {toCommaSeperatedAmount(
                                  ln.previousOnHandQuantity
                                )}
                              </div>
                              /
                              <div>
                                {toCommaSeperatedAmount(
                                  ln.changeOnHandQuantity
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="tb-flex">
                            <div>SKU Number</div>
                            <div className="">{ln.skuNumber}</div>
                          </div>
                          <div className="tb-flex">
                            <div className="sub-tb-flex">
                              <div>Sequence</div>/<div>Inventory</div>
                            </div>
                            <div className="sub-tb-flex">
                              <div>{ln.rollNumber}</div>/
                              <div>{ln.rollSkuNumber}</div>
                            </div>
                          </div>
                          <div className="tb-flex">
                            <div className="sub-tb-flex">
                              <div>Lot</div>/<div>Bin</div>
                            </div>
                            <div className="sub-tb-flex">
                              <div>{ln.vendorBatchNumber}</div>/
                              <div>{ln.aisleInfoText}</div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="">
                            <span className="_imp">{ln.fabricStyleCode}</span>(
                            {ln.fabricStyleName}) <br />{" "}
                            {ln.fabricStyleColorCode} -{" "}
                            <span className="imp">{ln.locationCode}</span> (
                            {ln.uomCode})
                          </div>
                          <div className="">
                            <span className="_imp">{ln.updateEntityCode}</span>{" "}
                            - {ln.updateEntityType}
                          </div>
                          <div className="">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th className="text-right">OnHand</th>
                                  <th className="text-right">Open</th>
                                  <th className="text-right">Change</th>
                                  <th className="text-center"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="text-right">
                                    {ln.onHandQuantity}
                                  </td>
                                  <td className="text-right">
                                    {ln.previousOnHandQuantity}
                                  </td>
                                  <td className="text-right">
                                    {ln.changeOnHandQuantity}
                                  </td>
                                  <td className="text-center">
                                    <div className="list-icon-wrap flex-end">
                                      <div
                                        className="icon-wrap"
                                        onClick={() => MoreOptionHandler(ln)}
                                      >
                                        <MOREOPTIONICON />
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}
                      <hr />
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>
      ) : null}
      <InValidAccess isShow={isAccessible} clickHandler={onClose} />
    </>
  );
}
